import axios from "axios";
import store from "../store";
import { logoutUser } from "../actions/authActions";
import { toast } from "react-toastify";

const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      (error.response.status === 401 ||
        error.response.status === 403 ||
        error.response.status === 404) &&
      error.response.data?.status === "error" &&
      error.response.data?.message === "You are not authorized"
    ) {
      store.dispatch(logoutUser());

      // toast.error('Your session has expired. Please login again.');
    }
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.request.use(
  (config) => {
    const slug = process.env.REACT_APP_STOREFRONT_SLUG;
    if (slug && String(slug).trim()) {
      config.headers["X-Storefront"] = String(slug).trim().toLowerCase();
    }
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
